import { render, staticRenderFns } from "./OutputsTab.vue?vue&type=template&id=586d5a5c&"
import script from "./OutputsTab.vue?vue&type=script&lang=js&"
export * from "./OutputsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports